var WindowTransformerService = /** @class */ (function () {
    function WindowTransformerService() {
    }
    WindowTransformerService.prototype.getContext = function (window, environment) {
        if (window === null || window === void 0 ? void 0 : window.globalAnalyticsParams) {
            var _a = window === null || window === void 0 ? void 0 : window.globalAnalyticsParams, siteName = _a.siteName, languageSelector = _a.languageSelector;
            return this.setConfigOnGlobalAnalyticsParams(siteName, languageSelector);
        }
        else if (environment === null || environment === void 0 ? void 0 : environment.localConfiguration) {
            var _b = environment === null || environment === void 0 ? void 0 : environment.localConfiguration, siteContext = _b.siteContext, languageSelector = _b.languageSelector;
            return this.setConfigOnGlobalAnalyticsParams(siteContext, languageSelector);
        }
        return {};
    };
    WindowTransformerService.prototype.setupCwpServices = function (hrefResolver, assetPathResolver, servicePathProvider, window, environment, appName) {
        var configurations = this.setConfigOnBlk(window, environment, appName);
        hrefResolver.setUrlMap(configurations.urlMap || {});
        assetPathResolver.setPath(configurations.assetPathPrefix || '');
        servicePathProvider.setServiceMap(configurations.providedServiceMap || {});
    };
    WindowTransformerService.prototype.setConfigOnGlobalAnalyticsParams = function (siteContext, languageSelector) {
        return {
            siteContext: siteContext,
            languageSelector: languageSelector,
        };
    };
    WindowTransformerService.prototype.setConfigOnBlk = function (window, environment, appName) {
        if (window === null || window === void 0 ? void 0 : window.BLK) {
            var appConfig = window === null || window === void 0 ? void 0 : window.BLK[appName];
            if (!appConfig) {
                return window === null || window === void 0 ? void 0 : window.BLK;
            }
            else {
                return appConfig;
            }
        }
        return environment !== null && environment !== void 0 ? environment : {};
    };
    return WindowTransformerService;
}());
export { WindowTransformerService };
//# sourceMappingURL=window-transformer.service.js.map